import { useContext } from 'react';
import { Confirm, ConfirmationModalContext } from './ConfirmationDialogContext';

export function useConfirmationDialog(): Confirm {
    const { confirm } = useContext(ConfirmationModalContext);

    return confirm;
}
